import PropTypes from "prop-types"
import classnames from "classnames"
import { formatLongDate } from "helpers/formatters/dates"
import DailyDetails from "./components/daily-details"
import ContributorsDetails from "modules/risk-contributors"
import "./style.scss"

function AnalyzeRiskDetails({
  selectedDate,
  selected,
  selectedValue,
  details,
  viewType,
  displayType,
  order,
  show,
  hide,
  sort,
  drift,
  openFactorProfile,
  openSecurityProfile,
  contributorsGrouping,
  setContributorsGrouping,
  showGroup,
  hideGroup,
  selectedGroup,
  selectedOption,
  groupSort,
  groupOrder,
  toggleShowNotHeld,
  selectedViews,
  showSegment,
}) {
  return <div className={classnames("modules_analyze-risk-details", { "show-segment": showSegment })}>
    <h4 className="header">As of {formatLongDate(selectedDate)}</h4>
    {!selected
      ? <DailyDetails {...{
          drift,
          viewType,
          openFactorProfile,
          displayType,
          factorTable: displayType !== "total" && displayType !== "factors",
          data: details,
          show,
          groupSort,
          groupOrder,
        }}
      />
      : <ContributorsDetails {...{
          selectedDate,
          viewType,
          openSecurityProfile,
          openFactorProfile,
          hide,
          sort,
          order,
          selected,
          selectedValue,
          showGroup,
          hideGroup,
          selectedGroup,
          setContributorsGrouping,
          contributorsGrouping,
          selectedOption,
          toggleShowNotHeld,
          details,
          show,
          groupOrder,
          selectedViews,
          showSegment,
        }}
      />}
  </div>
}

AnalyzeRiskDetails.propTypes = {
  selectedDate: PropTypes.string.isRequired,
  selected: PropTypes.object,
  selectedValue: PropTypes.number.isRequired,
  details: PropTypes.array.isRequired,
  viewType: PropTypes.string.isRequired,
  displayType: PropTypes.string.isRequired,
  selectedOption: PropTypes.object.isRequired,
  order: PropTypes.object.isRequired,
  openSecurityProfile: PropTypes.func.isRequired,
  openFactorProfile: PropTypes.func.isRequired,
  show: PropTypes.func.isRequired,
  hide: PropTypes.func.isRequired,
  sort: PropTypes.func.isRequired,
  drift: PropTypes.object.isRequired,
  contributorsGrouping: PropTypes.object,
  setContributorsGrouping: PropTypes.func.isRequired,
  showGroup: PropTypes.func.isRequired,
  hideGroup: PropTypes.func.isRequired,
  selectedGroup: PropTypes.object,
  filtersVisible: PropTypes.bool.isRequired,
  groupSort: PropTypes.func.isRequired,
  groupOrder: PropTypes.object.isRequired,
  toggleShowNotHeld: PropTypes.func.isRequired,
  selectedViews: PropTypes.array,
  showSegment: PropTypes.bool,
}

export default AnalyzeRiskDetails
